<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" [breakpoints]="{'960px': '90vw', '640px': '95vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="saveCertificationEdits()">
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Employee</b>
            </div>
            <div class="col-8">
              <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUser"
                              [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                              [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                              (onSelect)="setUserAfterStaffChange($event)" [forceSelection]="true"
                              (onClear)="clearUserAfterClear($event)"></p-autoComplete>
              <app-validation-message [form]="form" [path]="'userId'" [label]="'Employee'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">              
            </div>
            <div class="col-8">
              <p-checkbox [(ngModel)]="showOnlyActiveEmployees" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
              <b style="margin-left: 2px;">Show only active employees</b>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Certification Type</b>
            </div>
            <div class="col-8">
              <i *ngIf="!certificationTypes" class="material-icons rotate text-muted">loop</i>
              <p-select styleClass="app-select mt-2" [options]="certificationTypes" formControlName="certificationTypeId" optionLabel="label" optionValue="value" (onChange)="certificationTypeChanged()"></p-select>
              <app-validation-message [form]="form" [path]="'certificationTypeId'" [label]="'Certification Type'"></app-validation-message>
            </div>
          </div>

          <div class="row" *ngIf="isBlsCertification()">
            <div class="col-4 d-flex align-items-center">
              <b>BLS Certificate</b>
            </div>
            <div class="col-8 mt-2">
              <label class="btn btn-secondary mb-0">
                <input type="file" hidden="hidden" #fileInput accept=".pdf,.jpg,.jpeg,.png" (change)="changedFile(fileInput)" />
                <i class="fal fa-upload mr-1"></i> Add BLS Card
              </label>
              <span class="ml-2" *ngIf="form.get('uploadedFile').value">
                {{form.get('uploadedFile').value.name}}
                <i class="fal fa-fw fa-trash pointer text-danger" (click)="removeUploadedFile(fileInput)" title="Remove File"></i>
              </span>
              <app-validation-message [form]="form" [path]="'uploadedFile'" [label]="'BLS Certificate'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Instructor</b>
            </div>
            <div class="col-8 mt-2">
              <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedInstructor" 
                              [suggestions]="instructorList" (completeMethod)="getInstructorList($event)" field="name" dataKey="id"
                              [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                              (onSelect)="setInstructorAfterInstructorChange($event)" [forceSelection]="true"
                              (onClear)="clearInstructorAfterClear($event)"></p-autoComplete>
              <app-validation-message [form]="form" [path]="'instructorId'" [label]="'Instructor'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
            </div>
            <div class="col-8">
              <p-checkbox [(ngModel)]="showOnlyCurrentInstructors" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
              <b style="margin-left: 2px;">Show only current instructors</b>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Issue Date</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="issueDateString" />
              <app-validation-message [form]="form" [path]="'issueDateString'" [label]="'Issue Date'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Expiration Date</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="expirationDateString" />
              <app-validation-message [form]="form" [path]="'expirationDateString'" [label]="'Expiration Date'"></app-validation-message>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col-5 text-left pl-0">
        <i class="material-icons rotate text-muted" *ngIf="disableButtons">loop</i>
        <button class="btn btn-secondary ml-2" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col-2 text-center"></div>
      <div class="col-5 text-right pr-0">
        <button class="btn btn-primary" type="button" (click)="saveCertificationEdits()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
